import DashboardNavigation from "../../../components/Navigation/DashboardNavigation";

import { Outlet } from "react-router-dom";
import Notification from "../../../components/Notification/Notification";

export default function Home() {
  return (
    <>
      <Notification type={"normal"} title={""} />
      <div className="min-h-full bg-gray-100">
        <DashboardNavigation />
        <Outlet />
      </div>
    </>
  );
}
